import commonConstants from "./commonConstants";
import { Methods, UrlGenerator } from "./type";

export function urlGenerator(domain = "payping.ir"): UrlGenerator {
  let ADMIN_AUTH_URL = `https://oauth.${domain}`;
  switch (domain) {
    case "peypin.ir":
      ADMIN_AUTH_URL = "https://oauth.payping.io";
      break;
    case "payping.app":
      ADMIN_AUTH_URL = "https://oauth.payping.app";
      break;
    case "manatadbir.ir":
      ADMIN_AUTH_URL = "https://oauth.manatadbir.ir";
      break;
    default:
      break;
  }
  const AUTH_URL = `https://oauth.${domain}`;
  const BASE_URL = `https://api.${domain}`;
  const cdn = "https://statics.payping.ir";
  const PPWhiteLogoEn = `${cdn}/Payping-logo/full%20logo/english/white/SVG/payping.svg`;
  const PPFullColorLogoEn = `${cdn}/Payping-logo/full%20logo/english/fullcolor/SVG/payping.svg`;
  const PPFullColorLogoFa = `${cdn}/Payping-logo/full%20logo/persian/fullcolor/0.5x/Asset%204%400.5x.png`;
  const logo = {
    PPFullColorLogoEn,
    PPFullColorLogoFa,
    PPWhiteLogoEn,
  };

  return { ADMIN_AUTH_URL, AUTH_URL, BASE_URL, logo };
}

export const cdn = "https://statics.payping.ir";

const PPWhiteLogoEn = `${cdn}/Payping-logo/full%20logo/english/white/SVG/payping.svg` as const;
const PPFullColorLogoEn = `${cdn}/Payping-logo/full%20logo/english/fullcolor/SVG/payping.svg` as const;
const PPFullColorLogoFa = `${cdn}/Payping-logo/full%20logo/persian/fullcolor/0.5x/Asset%204%400.5x.png` as const;

const MAIN_HOST = (process.env.REACT_APP_DOMAIN || process.env.NEXT_PUBLIC_DOMAIN) as string;
const LANDING_URL = `https://www.${MAIN_HOST}` as const;
const BASE_URL = `https://api.${MAIN_HOST}` as const;
const AUTH_URL = `https://oauth.${MAIN_HOST}` as const;
const DASH_URL = `https://app.${MAIN_HOST}` as const;
const LOGOFF_URL = `https://www.${MAIN_HOST}` as const;
const TERMS_URL = `https://www.${MAIN_HOST}/terms` as const;
const STORAGE_URL = `https://statics.${MAIN_HOST}` as const;
const CRM_URL = "https://crm.manatadbir.ir";
const PAYMENT_URL = (username: string): string => `https://www.${MAIN_HOST}/@${username}`;
const ONBOARDING_URL = `https://onb.${MAIN_HOST}` as const;
const DEVCONSOLE_URL = `https://developer.${MAIN_HOST}` as const;
const HELP_URL = `https://www.payping.io/help/`;
const BLOG_URL = `https://payping.ir/blog/`;
const DOCS_URL = `https://docs.payping.ir`;
const GIT_PAGES_URL = `https://payping.github.io`;
const PPNG = process.env.REACT_APP_DOMAIN?.endsWith("dev") ? `https://ppng.payping.dev` : `https://ppng.ir`;
const SHARE_STORAGE_URL = `https://sharestorage.${MAIN_HOST}` as const;
const WP_LANDING_URL = `https://payping.io/landing`;
const ClientRegisterUrl = (registerId: string): string =>
  `https://oauth.payping.ir/Client/ClientRegister?registerId=${registerId}`;

const AccessClientTokenToServicesMethods: Methods[] = [
  { enable: true, names: ["timeline"], title: "سرویس تاریخچه پیمایش" },
  { enable: true, names: ["invoice", "template", "schedule"], title: "سرویس فاکتور" },
  { enable: true, names: ["customer"], title: "سرویس مشتری" },
  { enable: true, names: ["organization"], title: "سرویس سازمانی" },
  { enable: false, names: ["pay", "request"], title: "سرویس پرداخت" },
  { enable: false, names: ["report", "withdraw"], title: "سرویس گزارشات" },
  { enable: true, names: ["product", "coupon", "category", "permalink"], title: "سرویس آیتم مالی" },
  { enable: false, names: ["Upload"], title: "سرویس فایل‌منیجر" },
  { enable: false, names: ["user"], title: "سرویس مدیریت کاربران" },
  { enable: false, names: ["integration"], title: "سرویس اطلاع رسانی" },
];

const DevelopmentBaseUrlConfig: Methods[] = [
  { enable: false, names: ["timeline"], title: "سرویس تاریخچه پیمایش", url: "http://localhost:5031" },
  { enable: false, names: ["invoice", "template", "schedule"], title: "سرویس فاکتور", url: "http://localhost:5018" },
  { enable: false, names: ["customer"], title: "سرویس مشتری", url: "http://localhost:5038" },
  { enable: false, names: ["pay", "request"], title: "سرویس پرداخت", url: "http://localhost:5013" },
  {
    enable: false,
    names: ["product", "coupon", "category", "permalink"],
    title: "سرویس آیتم مالی",
    url: "http://localhost:5014",
  },
  { enable: false, names: ["Upload"], title: "سرویس فایل‌منیجر", url: "http://localhost:5000" },
  { enable: false, names: ["user"], title: "سرویس مدیریت کاربران", url: "http://localhost:5014" },
  { enable: false, names: ["integration"], title: "سرویس اطلاع رسانی", url: "http://localhost:5012" },
];

/* eslint-disable sort-keys */
const DashboardRoutes = {
  customer: {
    root: "/customer",
    create: "/customer/create",
    createBulk: "/customer/createBulk",
    edit: "/customer/edit/:code",
    list: "/customer/list",
  },
  settlement: {
    root: "/settlement",
    create: "/settlement/create",
    success: "/settlement/success",
    transaction: "/settlement/transaction",
    failed: "/settlement/failed",
    overview: "/settlement/overview",
    report: { list: "/settlement/report", detail: "/settlement/report/:code" },
    id: "/settlement/id",
    createId: "/settlement/id/create",
  },
  invoice: {
    root: "/invoice",
    coupon: {
      root: "/invoice/coupon",
      create: "/invoice/coupon/create",
      detail: "/invoice/coupon/detail/:code",
      edit: "/invoice/coupon/edit/:code",
      list: "/invoice/coupon/list",
    },
    correction: "/invoice/correction/:code",
    create: "/invoice/create",
    edit: "/invoice/edit/:code",
    invoice: "/invoice/:code",
    list: "/invoice/list",
    show: "/invoice/show",
  },
  ipg: {
    root: "/ipg",
    document: "/ipg/document",
    oauth: {
      root: "/ipg/oauth",
      create: "/ipg/oauth/create",
      edit: "/ipg/oauth/edit/:clientId",
      renew: "/ipg/oauth/renew/:clientId",
      show: "/ipg/oauth/show",
    },
    service: {
      root: "/ipg/services",
      category: "/ipg/services/:category",
      detail: "/ipg/services/detail/:name",
      messaging: "/ipg/services/message/:name",
    },
    token: {
      root: "/ipg/token",
      create: "/ipg/token/create",
      edit: "/ipg/token/edit/:clientId",
      renew: "/ipg/token/renew/:clientId",
      show: "/ipg/token/show",
    },
  },
  home: {
    root: "/home",
    overview: "/home/overview",
    messages: "/home/messages",
  },
  platform: {
    root: "/platform",
    list: "/platform/list",
    create: "/platform/create",
    detail: "/platform/detail/:clientId",
    edit: "/platform/edit/:clientId",
    renew: "/platform/renew/:clientId",
    show: "/platform/show",
    clientRegister: {
      root: "/platform/:clientId/clientRegister",
      create: "/platform/:clientId/clientRegister/create",
      edit: "/platform/:clientId/clientRegister/edit/:code",
      detail: "/platform/:clientId/clientRegister/detail/:code",
      getLink: "/platform/:clientId/clientRegister/getLink",
      list: "/platform/:clientId/clientRegister/list",
    },
    payment: {
      root: "/platform/:clientId/payment",
      detail: "/platform/:clientId/payment/detail/:code",
      list: "/platform/:clientId/payment/list",
    },
    user: {
      root: "/platform/:clientId/user",
      detail: "/platform/:clientId/user/detail/:code",
      list: "/platform/:clientId/user/list",
    },
  },
  product: {
    root: "/product",
    coupon: {
      root: "/product/coupon/",
      create: "/product/coupon/create",
      detail: "/product/coupon/detail/:code",
      edit: "/product/coupon/edit/:code",
      list: "/product/coupon/list",
    },
    create: "/product/create",
    createBulk: "/product/createBulk",
    detail: "/product/detail/:code",
    edit: "/product/edit/:code",
    list: "/product/list",
  },
  report: {
    root: "/report",
    itemSale: "/report/itemSale",
    summation: "/report/summation",
    transactions: {
      root: "/report/transactions",
      transactionDetails: "/report/transactions/:code",
    },
    withdraws: {
      root: "/report/withdraws",
      withdrawDetails: "/report/withdraws/:code",
    },
  },
  requestMoney: {
    root: "/requestMoney",
    bulkRequest: "/requestMoney/bulkRequest",
    details: "/requestMoney/list/:code",
    list: "/requestMoney/list",
    request: "/requestMoney/request",
  },
  user: {
    root: "/user",
    client: "/user/client",
    disable2fa: "/user/settings/disable2fa",
    enable2fa: "/user/settings/enable2fa",
    profile: {
      root: "/user/profile",
      bank: "/user/profile/bank",
      business: "/user/profile/business",
      local: "/user/profile/local",
      personal: "/user/profile/personal",
      social: "/user/profile/social",
    },
    referral: "/user/referral",
    requestWithdraw: "/user/requestWithdraw",
    settings: {
      root: "/user/settings",
      "2fa": "/user/settings/2fa",
      display: "/user/settings/display",
      messaging: "/user/settings/messaging",
      password: "/user/settings/password",
      terminal: "/user/settings/terminal",
    },
    upgrade: "/user/upgrade",
    terminals: "/user/terminals",
  },
} as const;

/* eslint-enable sort-keys */

const webConstants = {
  ...commonConstants,
  AUTH_URL,
  AccessClientTokenToServicesMethods,
  BASE_URL,
  BLOG_URL,
  CRM_URL,
  ClientRegisterUrl,
  DASH_URL,
  DEVCONSOLE_URL,
  DOCS_URL,
  DashboardRoutes,
  DevelopmentBaseUrlConfig,
  GIT_PAGES_URL,
  HELP_URL,
  LANDING_URL,
  LOGOFF_URL,
  MAIN_HOST,
  ONBOARDING_URL,
  PAYMENT_URL,
  PPFullColorLogoEn,
  PPFullColorLogoFa,
  PPNG,
  PPWhiteLogoEn,
  SHARE_STORAGE_URL,
  STORAGE_URL,
  TERMS_URL,
  WP_LANDING_URL,
} as const;

export default webConstants;
